import React from "react";
import { Modal } from "antd";
import "./Modal.scss";
import LogoutIcon from "../../assets/wrong_input.png";
export default function AlertModal({ open, setOpen, errorMsg }) {
    return (
        <div>
            <Modal title="" visible={open} onCancel={() => { setOpen(!open); }} footer={null} header={null} closeIcon={null} width={500}>
                <div className="alert-container">
                    <div className="alert-topview">
                        <img className="alert-icon" src={LogoutIcon} alt="icon" />
                    </div>
                    <div className="alert-bottomview">
                        <div className="alert-alertview">
                            <p className="logoutalertsubheadertext">{errorMsg ? errorMsg : ""}</p>
                            <button className="logoutCancel logoutCancelText" onClick={() => setOpen(!open)}>Close</button>
                        </div>
                    </div>
                </div>
            </Modal>
        </div>
    )
}